"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobile_token_pin_png_1 = __importDefault(require("../../../../assets/images/mobile-token-pin.png"));
const ico_close_png_1 = __importDefault(require("../../../../assets/images/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/images/bg_wid_gradient.png"));
const bg_field_png_1 = __importDefault(require("../../../../assets/images/bg_field.png"));
const bg_notify_success_png_1 = __importDefault(require("../../../../assets/images/bg_notify_success.png"));
const ico_success_png_1 = __importDefault(require("../../../../assets/images/ico-success.png"));
const styles_1 = require("@mui/styles");
const familyFontConst = '"Open Sans", Helvetica,Arial,sans-serif';
const paddingConst = '6px 10px 8px';
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        border: 0,
        outline: 0,
        position: 'relative',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: familyFontConst,
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x scroll left bottom #fff`,
        overflow: 'hidden',
        width: '600px',
        zIndex: 1102
    },
    DialogContentOuter: {
        width: '600px',
        backgroundColor: '#f7f7f7'
    },
    DialogNotification: {
        position: 'absolute'
    },
    DialogContent: {
        borderWidth: 0,
        width: '600px',
        overflow: 'hidden',
        position: 'relative',
        padding: paddingConst
    },
    WrapIcon: {
        position: 'relative',
        background: `url(${mobile_token_pin_png_1.default}) no-repeat`,
        width: 120,
        height: 175,
        display: 'block',
        marginRight: '5px',
        backgroundSize: 'contain',
        marginTop: '7px'
    },
    IconClose: {
        position: 'relative',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        marginRight: '5px',
        display: 'block',
        marginTop: '-33px',
        float: 'right',
        cursor: 'pointer',
        zIndex: 1103
    },
    ListItem: {
        overflow: 'hidden',
        padding: '6px 10px 8px',
        position: 'relative',
        width: '562px',
        marginTop: '-7px'
    },
    ListItemText: {
        width: '415px',
        fontSize: '14px',
        marginLeft: '29px',
        fontWeight: 'normal',
        paddingTop: '28px',
        color: '#2f3c54'
    },
    text: {
        padding: '38px'
    },
    formLink: {
        color: '#1480b7',
        textDecoration: 'underline'
    },
    typography: {
        'font-size': '14px',
        'margin-left': '-5px',
        'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#2f3c54',
        fontWeight: 'normal',
        fontFamily: familyFontConst,
        width: '510px'
    },
    OtpError: {
        color: '#ff0000',
        fontFamily: familyFontConst,
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-25px',
        marginTop: '16px'
    },
    note2: {
        'margin-top': '-13px',
        width: '276px'
    },
    OneTokenTitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        margin: '10px 10px 0',
        padding: '5px 10px',
        fontFamily: familyFontConst,
        fontStyle: 'normal',
        fontSize: '166%',
        width: '530px'
    },
    TitleOutline: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    TitleContent: {
        padding: '8px 10px',
        position: 'relative'
    },
    Link: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: familyFontConst,
        cursor: 'pointer'
    },
    OTP: {
        borderRadius: '2px',
        background: `url(${bg_field_png_1.default}) repeat-x left top #fff`,
        border: '1px solid',
        borderColor: '#e1e5eb',
        color: '#2f3c54',
        fontWeight: 600,
        outline: '0',
        padding: '6px 9px',
        fontSize: '13px',
        height: '37px',
        maxWidth: 'inherite',
        boxSizing: 'border-box',
        verticalAlign: 'middle'
    },
    InputFocus: {
        border: '1px solid #869cc1',
        boxShadow: 'inset #e6e6e6 0 0 4px 0',
        zIndex: 1
    },
    InputHeight: {
        height: '37px !important'
    },
    OTPInputOutline: {
        display: 'block',
        marginLeft: '-35px',
        marginTop: '9px'
    },
    OTPInputTitle: {
        marginBottom: '-15px',
        padding: '10px'
    },
    OTPInput: {
        paddingLeft: '10px',
        paddingBottom: '0px',
        overflow: 'hidden',
        padding: paddingConst,
        position: 'relative',
        float: 'left',
        width: '200px'
    },
    OPTInputContent: {
        backgroundColor: 'transparent',
        display: 'inline-block',
        marginBottom: '2px',
        marginLeft: '-3px',
        padding: '4px',
        borderRadius: '5px'
    },
    fontInfo: {
        fontFamily: familyFontConst,
        fontWeight: 600
    },
    OTPLink: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: familyFontConst,
        cursor: 'pointer'
    },
    resendLink: {
        paddingTop: '20px',
        marginTop: '-21px'
    },
    resendTips: {
        color: 'Gray',
        fontSize: '11px',
        paddingTop: '16px',
        left: 0,
        lineHeight: '17px',
        top: 0,
        wordSpacing: '.0125em'
    },
    updateMobileTips: {
        marginBottom: '-10px',
        marginTop: '-10px',
        paddingTop: '16px',
        fontSize: '11px',
        color: 'Gray',
        left: 0,
        top: 0,
        wordSpacing: '.0125em'
    },
    SMSTips: {
        fontWeight: 'bold',
        color: '#2f3c54',
        fontSize: '12px',
        fontFamily: familyFontConst,
        left: 0,
        lineHeight: '17px',
        top: 0,
        wordSpacing: '.0125em'
    },
    bodyTitle: {
        paddingTop: '10px',
        borderBottom: '1px solid #ded9d4',
        color: '#697283',
        fontSize: '146%',
        fontWeight: 'bold',
        margin: '25px 0px 10px 0px',
        paddingBottom: '4px',
        paddingLeft: 0,
        paddingRight: 0,
        fontStyle: 'normal',
        position: 'relative',
        fontFamily: familyFontConst
    },
    // SubmitOutline: {
    //   alignItems: 'center',
    //   flexWrap: 'wrap',
    //   paddingTop: '10px',
    //   margin: '10px 10px 0',
    //   display: 'block',
    // },
    // Submit: {
    //   boxSizing: 'border-box',
    //   background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
    //   border: '1px solid #595959',
    //   borderRadius: '5px',
    //   fontWeight: 'bold',
    //   textAlign: 'center',
    //   padding: '9px 12px',
    //   color: '#FFF',
    //   display: 'block',
    //   float: 'right',
    //   fontSize: '13px',
    //   height: 'auto',
    //   lineHeight: 'normal',
    //   margin: 0,
    //   minWidth: '126px',
    //   outline: 0,
    //   position: 'relative',
    //   marginRight: '-15px',
    //   textTransform: 'none',
    //   textShadow: 'none',
    //   fontFamily: familyFontConst,
    //   marginTop: '8px',
    //   marginBottom: '13px',
    // },
    SubmitOutline: {
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingTop: '10px',
        margin: '10px 10px 0',
        display: 'block',
        '& button': {
            boxSizing: 'border-box',
            background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
            border: '1px solid #595959',
            borderRadius: '5px',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '9px 12px',
            color: '#FFF',
            display: 'block',
            float: 'right',
            fontSize: '13px',
            height: 'auto',
            lineHeight: 'normal',
            margin: 0,
            minWidth: '126px',
            outline: 0,
            position: 'relative',
            marginRight: '-15px',
            textTransform: 'none',
            textShadow: 'none',
            fontFamily: familyFontConst,
            marginTop: '8px',
            marginBottom: '13px'
        }
    },
    notifySuccess: {
        margin: '10px',
        padding: 0,
        width: '558px',
        display: 'block'
    },
    notifyInnerContent: {
        margin: '0 -13px',
        background: `url(${bg_notify_success_png_1.default}) repeat-x left top #e1f4cb`,
        borderColor: '#ceedc1',
        border: '1px solid #e5e5e5',
        borderRadius: '5px',
        display: 'block',
        padding: '10px',
        position: 'relative'
    },
    NotifySuccessIcon: {
        background: `url(${ico_success_png_1.default}) center / contain no-repeat`,
        display: 'block',
        float: 'left',
        height: '28px',
        marginLeft: '18px',
        marginBottom: '6px',
        width: '28px',
        marginTop: '-17px'
    },
    notifySuccessText: {
        marginLeft: '-49px',
        marginTop: '-12px',
        marginBottom: '-12px'
    },
    commonWordStyle: {
        left: 0,
        top: 0,
        wordSpacing: '.0125em'
    },
    notifyTips1: {
        color: '#5cbf65',
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 'bold',
        margin: 0,
        padding: 0
    },
    notifyTips2: {
        margin: 0,
        color: '#333',
        fontSize: '13px',
        lineHeight: '18px',
        padding: '0 0 10px 0'
    }
}));
